import NavbarPill from "./NavbarPill";
import Footer from "./Footer";
import FixingGold from "./FixingGold";
import { Outlet } from "react-router-dom";
import NavbarNew from "./NavbarNew";

export default function Layout() {
    return (
        <div>
            {/* <NavbarPill /> */}
            <NavbarNew />
            <Outlet />
            <FixingGold />
            <Footer />
        </div>
    );
}